'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { WaitlistSignupDialog } from './_components/WaitlistSignupDialog';
import { WaitlistSignupProvider } from './WaitlistSignupContext';
export function MarketingWaitlistChrome(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <WaitlistSignupDialog />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <WaitlistSignupProvider>{children}{t1}</WaitlistSignupProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}